/**
 * VFXAbilityDefs - Index for all ability-specific visual effect definitions
 * 
 * This file consolidates definitions from class-specific files.
 */

import { VFXEffectConfig } from '../VFXEffectRegistry';
import { COMMON_VFX } from './abilities/CommonVFX';
import { WARRIOR_VFX } from './abilities/WarriorVFX';
import { MAGE_VFX } from './abilities/MageVFX';
import { PALADIN_VFX } from './abilities/PaladinVFX';
import { RANGER_VFX } from './abilities/RangerVFX';
import { ASSASSIN_VFX } from './abilities/AssassinVFX';
import { PROCEDURAL_VFX } from './abilities/ProceduralVFX';
import { STATUS_VFX } from './abilities/StatusVFX';
import { WARLOCK_VFX } from './abilities/WarlockVFX';
import { SHAMAN_VFX } from './abilities/ShamanVFX';
import { DRUID_VFX } from './abilities/DruidVFX';
import { MOVEMENT_ABILITY_VFX } from './abilities/MovementAbilityVFX';
import { PRIEST_SUPPORT_VFX } from './abilities/PriestSupportVFX';
import { REACTION_VFX } from './abilities/ReactionVFX';
import { DEATH_VFX } from './abilities/DeathVFX';
import { PARTICLE_PRESETS } from './ParticlePresets';
import { CONSUMABLE_VFX } from './abilities/ConsumableVFX';
import { THROWING_STAR_VFX } from './abilities/ThrowingStarVFX';
import { DEFENSIVE_STATE_VFX } from './abilities/DefensiveStateVFX';
import { WARRIOR_KIT_VFX } from './abilities/WarriorKitVFX';
import { PALADIN_KIT_VFX } from './abilities/PaladinKitVFX';
import { ROGUE_KIT_VFX } from './abilities/RogueKitVFX';
import { HUNTER_KIT_VFX } from './abilities/HunterKitVFX';
import { MAGE_KIT_VFX } from './abilities/MageKitVFX';
import { WARLOCK_KIT_VFX } from './abilities/WarlockKitVFX';
import { DRUID_KIT_VFX } from './abilities/DruidKitVFX';
import { PRIEST_KIT_VFX } from './abilities/PriestKitVFX';
import { SHAMAN_KIT_VFX } from './abilities/ShamanKitVFX';
import { ADVANCED_DAMAGE_BUFF_VFX } from './abilities/AdvancedDamageBuffVFX';
import { WARLOCK_AFFLICTION_VFX } from './abilities/WarlockAfflictionVFX';
import { WARLOCK_VEIL_VFX } from './abilities/WarlockVeilVFX';
import { LANTERNSKIP_VFX } from './abilities/LanternskipVFX';

export const ABILITY_VFX_EFFECTS: VFXEffectConfig[] = [
  ...COMMON_VFX,
  ...WARRIOR_VFX,
  ...MAGE_VFX,
  ...PALADIN_VFX,
  ...RANGER_VFX,
  ...ASSASSIN_VFX,
  ...PROCEDURAL_VFX,
  ...STATUS_VFX,
  ...CONSUMABLE_VFX,
  ...WARLOCK_VFX,
  ...SHAMAN_VFX,
  ...DRUID_VFX,
  // Class movement abilities from plan 04a (Stormstride, Harebound, Pact Door, Lightfall).
  ...MOVEMENT_ABILITY_VFX,
  ...LANTERNSKIP_VFX,
  // Priest support (Brightstep, lane AM 2026-10-08).
  ...PRIEST_SUPPORT_VFX,
  ...REACTION_VFX,
  // Death/kill grammar (KillBeatDirector self-registers idempotently at
  // runtime; the spread adds dashboard/contract visibility — lane rule 4).
  // DEATH_VFX already includes KILL_CONFIRM_VFX — never spread both.
  ...DEATH_VFX,
  ...PARTICLE_PRESETS,
  ...THROWING_STAR_VFX,
  ...DEFENSIVE_STATE_VFX,
  // Plan 29 F9 kit identity (lane BX): warrior + paladin authored looks.
  ...WARRIOR_KIT_VFX,
  ...PALADIN_KIT_VFX,
  // Plan 29 F9 kit identity (lane BY): rogue + hunter authored looks.
  ...ROGUE_KIT_VFX,
  ...HUNTER_KIT_VFX,
  // Plan 29 F9 kit identity (lane BZ): mage + warlock authored looks.
  ...MAGE_KIT_VFX,
  ...WARLOCK_KIT_VFX,
  // Plan 29 F9 kit identity (lane CB): druid authored looks.
  ...DRUID_KIT_VFX,
  // Plan 29 F9 kit identity (lane CA): priest + shaman authored looks.
  ...PRIEST_KIT_VFX,
  ...SHAMAN_KIT_VFX,
  ...ADVANCED_DAMAGE_BUFF_VFX,
  ...WARLOCK_AFFLICTION_VFX,
  ...WARLOCK_VEIL_VFX,
];
